import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';

// Lazy load pages for code splitting
const HomePage = lazy(() => import('@/features/home/HomePage'));
const AboutPage = lazy(() => import('@/features/about/AboutPage'));
const ServicesPage = lazy(() => import('@/features/services/ServicesPage'));
const PlatformsPage = lazy(() => import('@/features/platforms/PlatformsPage'));
const BanyanProPage = lazy(() => import('@/features/products/banyanpro/BanyanProPage'));
const QAgentPage = lazy(() => import('@/features/products/qagent/QAgentPage'));
const HireAgentPage = lazy(() => import('@/features/products/hireagent/HireAgentPage'));
const TeamPage = lazy(() => import('@/features/team/TeamPage'));
const ContactPage = lazy(() => import('@/features/contact/ContactPage'));

// Loading fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-navy-900">
    <div className="flex flex-col items-center gap-4">
      <div className="w-8 h-8 border-2 border-teal-accent border-t-transparent rounded-full animate-spin" />
      <span className="text-slate-400 text-sm">Loading...</span>
    </div>
  </div>
);

export const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/platforms" element={<PlatformsPage />} />
        <Route path="/platforms/banyanpro" element={<BanyanProPage />} />
        <Route path="/platforms/qagent" element={<QAgentPage />} />
        <Route path="/platforms/hireagent" element={<HireAgentPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* Add more routes as needed */}
        <Route path="*" element={<HomePage />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
